export class Login {
    username: string;
    password: string;
    persistSession: boolean;
}



// WEBPACK FOOTER //
// ./src/models/forms/Login.ts